
// This exports the plugin object.
export default {
  // The install method will be called with the Vue constructor as         
  // the first argument, along with possible options
  install (Vue, options) {
    // Vue.loadScript("https://unpkg.com/axios/dist/axios.min.js").then(function(){
      const _auid = localStorage._auid
      const _axios = window.axios.create({
        baseURL: 'https://daily.archtransco.com:3000',
        // timeout: 10000,
        // data: {_auid:this._auid},
        // params: {_auid:this._auid},
        headers: {'X-ATL-Auth': _auid}
      });
      window.i_axios = _axios
      Vue.prototype.$axios = _axios
    // })
    

  }
}